import {
  Grid,
  GridItem,
  HStack,
  VStack,
  Text,
  Box,
  Flex,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  IconButton
} from "@chakra-ui/react";
import React, { useContext, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import AdminCard from "./components/AdminCard";
import AdminLeftSideBar from "./components/AdminLeftSideBar";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import DashboardCard from "./components/DashboardCard";
import { Helmet } from "react-helmet";
import { FiMenu } from "react-icons/fi";

const Admin = () => {
  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Helmet>
        <title>Admin | Techy India</title>
      </Helmet>

      <Flex w="100%" minH="100vh">
        {/* Desktop Sidebar */}
        <Box
          display={{ base: "none", md: "block" }}
          w={{ md: "250px", lg: "300px" }}
          position="sticky"
          top="0"
          h="100vh"
        >
          <AdminLeftSideBar />
        </Box>

        {/* Mobile Header & Content */}
        <Box flex="1" w="full">
          {/* Mobile Header */}
          <Flex
            display={{ base: "flex", md: "none" }}
            p={4}
            align="center"
            bg="gray.900"
            borderBottom="1px"
            borderColor="gray.700"
            position="sticky"
            top="0"
            zIndex="10"
            color="white"
          >
            <IconButton
              icon={<FiMenu />}
              onClick={onOpen}
              variant="ghost"
              aria-label="Open Menu"
              color="white"
              _hover={{ bg: "whiteAlpha.200" }}
            />
            <Text ml={4} fontWeight="bold">Admin Dashboard</Text>
          </Flex>

          {/* Content Area */}
          <Box w="full" p={{ base: 2, md: 0 }}>
            {location.pathname == "/admin" && <Navigate to={'/admin/users'} />}
            <Outlet />
          </Box>
        </Box>
      </Flex>

      {/* Mobile Drawer */}
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Menu</DrawerHeader>
          <DrawerBody p={0}>
            <AdminLeftSideBar onClose={onClose} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default Admin;
